import { League } from "../../../contracts"
export const mapLeagueUrl = (adjustPath: Function, league: League): League => {
        const urlParams = `${getURLName(league.sportName || "")}/${getURLName(league.name || "")}`;
        league.linkUrl = adjustPath(urlParams);
        return league;
}

const getURLName = (name: string): string => {
    return name.toLowerCase().replace(/- /g, "").replace(/ /g, "-");
}